module.exports = __webpack_public_path__ + "img/gb13871-92_160x190x15.prt.bd9a196e.jpg";